module.exports = __webpack_public_path__ + "media/images/icons/material/dribbble-4635f5c839da8bc5197c026988273178.svg";